import { warningNotification } from "@app/common/components/notifications";
import { Modal, ScrollArea } from "@mantine/core";
import QRScanner from "qr-scanner";
import { useEffect, useRef, useState } from "react";

export default function QRScannerComponent({
  handleSubmit,
  onClose,
  open,
  setQrScanner,
  trigger
}: {
  onClose: () => void;
  open: boolean;
  handleSubmit: (value: string) => void;
  setQrScanner: (value: number) => void;
  trigger: number;
}) {
  const [scanner, setScanner] = useState<QRScanner | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const extractOrderNumber = (text: string) => {
    const match = text.split("\n")[0].split(": ");
    return match ? match[1] : "";
  };

  const initializeScanner = async () => {
    if (videoRef.current) {
      let scanning = true;
      const newScanner = new QRScanner(
        videoRef.current,
        async (result) => {
          if (!scanning) {
            return;
          }
          scanning = false;
          const orderNumber = extractOrderNumber(String(result.data));
          if (orderNumber) {
            try {
              await handleSubmit(orderNumber);
              newScanner.stop();
            } catch (error) {
              warningNotification(
                "No se pudo procesar el código QR, intente nuevamente",
                "Intenta de nuevo"
              ).then(() => {
                scanning = true;
              });
            }
          } else {
            warningNotification(
              "El código QR no contiene un número de orden, verifique que este pertenezca a un ordenamiento",
              "intenta de nuevo"
            )?.then(() => {
              scanning = true;
            });
          }
        },
        {
          highlightScanRegion: true,
          highlightCodeOutline: true
        }
      );

      setScanner(newScanner);

      try {
        await newScanner.start();
      } catch (error) {
        throw new Error("Error al iniciar el escáner: " + error);
      }
    } else {
      setTimeout(initializeScanner, 100); // Reintentar tras 100ms
      throw new Error("Elemento de video no encontrado");
    }
  };

  useEffect(() => {
    if (open) {
      if (trigger === 0) {
        setQrScanner(trigger + 1);
      }
      initializeScanner();
    } else if (scanner) {
      scanner.stop();
      setScanner(null);
    }

    return () => {
      if (scanner) {
        scanner.stop();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, videoRef.current, trigger]);

  return (
    <Modal
      size={500}
      title="Escáner de QR"
      opened={open}
      onClose={onClose}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      <div className="flex justify-center items-center" key={trigger}>
        <video
          data-testid="videoScanner"
          ref={videoRef}
          style={{ width: "100%", height: "auto" }}
          autoPlay
          playsInline
        />
      </div>
    </Modal>
  );
}
